module.exports = __webpack_public_path__ + "static/img/news.685ba73a.png";